/**
 * Created by gusenlin on 2018/6/14.
 */
/* eslint-disable */
import store from '@/vuex/index';
import config from 'config';
import { getEnvironmentType } from '@/utils/environment';
import { NativeService } from '@/service/native/nativePluginService';

/**
 * 埋点统计
 * eventId： id
 * eventName： name
 * content [Array, string]
 *  Array: [{l: '111', v: '111'}, {l: '222', v: '222'}]
 *
 * */
export function registerMobstat(eventId, content, metrics) {
  NativeService().mobstat(eventId, content, metrics);
}

export function initPiwik() {
  return;
  if (!_paq) {
    return;
  }

  let u = 'https://matomo.huilianyi.com/';
  let loginType = getEnvironmentType('loginType');
  let siteId = getSiteId(loginType);
  _paq.push(['setTrackerUrl', u + 'piwik.php']);
  _paq.push(['setSiteId', siteId]);
}

export function registerPiwik(action, registerPerson) {
  return;
  if (!_paq) {
    return;
  }
  // 默认埋点
  let loginType = getEnvironmentType('loginType');
  let siteId = getSiteId(loginType);
  _paq.push(['setSiteId', siteId]);
  let myInfo = store.getters.getMyInfo;
  let tenantName = '未识别-';
  if (myInfo) {
    _paq.push(['setCustomDimension', 1, myInfo.tenantName]);
    _paq.push(['setCustomDimension', 2, myInfo.fullName]);
    _paq.push(['setCustomDimension', 3, myInfo.userOID]);
  }
  if (myInfo && myInfo.tenantName) {
    tenantName = myInfo.tenantName;
  } else {
    tenantName = tenantName + myInfo.companyName;
  }

  if (myInfo.tenantName) {
    _paq.push(['setDocumentTitle', tenantName + '/' + action]);
    _paq.push(['setCustomUrl', '']);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
  }
}

export function registerPiwikError(action) {
  return;
  if (!_paq) {
    return;
  }

  let myInfo = store.getters.getMyInfo;
  let tenantName = '未识别-';
  if (myInfo) {
    _paq.push(['setCustomDimension', 1, myInfo.tenantName]);
    _paq.push(['setCustomDimension', 2, myInfo.fullName]);
    _paq.push(['setCustomDimension', 3, myInfo.userOID]);
  }
  if (myInfo && myInfo.tenantName) {
    tenantName = myInfo.tenantName;
  } else {
    tenantName = tenantName + myInfo.companyName;
  }

  let dateStr = formatDate();
  _paq.push(['setDocumentTitle', tenantName + '/错误/' + myInfo.fullName + '/' + dateStr + '/' + action]);
  _paq.push(['setCustomUrl', '']);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
}

function formatDate(flag) {
  let date = new Date();
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let H = date.getHours();
  let f = date.getMinutes();
  m = m < 10 ? '0' + m : m + '';
  d = d < 10 ? '0' + d : d + '';
  f = f < 10 ? '0' + f : f + '';
  H = H < 10 ? '0' + H : H + '';
  if (flag) {
    return y + '-' + m + '-' + d;
  } else return y + '-' + m + '-' + d + ' ' + H + ':' + f;
}
//
// function isAuth() {
//   if (config.env === 'prod' || config.env === 'stage' || config.env === 'uat') {
//     return true;
//   } else {
//     return false;
//   }
// }

function getSiteId(loginType) {
  if (config.env === 'prod') {
    if (loginType == 'wx') {
      return '3';
    } else if (loginType == 'dd') {
      return '4';
    } else if (loginType == 'cd') {
      return '5';
    }
  } else {
    return '10';
  }
}

// function piwikScript() {
//   /*if(piwikFirst){
//       (function () {
//           var u = "https://matomo.huilianyi.com/";
//           var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
//           g.type = 'text/javascript';
//           g.async = true;
//           g.defer = true;
//           g.src = u + 'piwik.js';
//           s.parentNode.insertBefore(g, s);
//       })();
//       piwikFirst = false;
//   }*/
// }
